import { NgModule } from '@angular/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { RouterModule, Routes } from '@angular/router';
import { PrevisionDialogComponent } from './dialogs/prevision.dialog.component';
import { SharedModule } from '../shared.module';
import { ListComponent } from './pages/list/list.component';
import { MatDatepickerModule } from '@angular/material/datepicker';

const routes: Routes = [
  {
    path: '',
    component: ListComponent,
    data: { animation: 'isLeft' },
  },
];

@NgModule({
  declarations: [ListComponent, PrevisionDialogComponent],
  imports: [RouterModule.forChild(routes), SharedModule, MatMomentDateModule, MatDatepickerModule],
  providers: [{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }],
})
export class PrevisionsModule {}
